import React from 'react'

import Svg from '../../../../Svg'

const LowInventorySvg = () => (
  <Svg viewBox='0 0 68 46' fill='none'>
    <path
      d='M24.4193 46.0001H5.25788C4.66993 46.0001 4.19336 45.4394 4.19336 44.7477V35.9811H25.4838V44.7477C25.4838 45.4394 25.0072 46.0001 24.4193 46.0001Z'
      fill='#C4BCC4'
    />
    <path
      d='M26.8604 35.6142L20.1614 27.7331L19.3174 28.726L25.484 35.981H27.6131C27.3406 35.981 27.0682 35.8587 26.8604 35.6142Z'
      fill='#535058'
    />
    <path
      d='M24.4198 46H11.6456C11.0576 46 10.5811 45.4393 10.5811 44.7476V35.981L18.0327 27.2144L25.4844 35.981V44.7476C25.4844 45.4393 25.0078 46 24.4198 46Z'
      fill='#F4EBF0'
    />
    <path
      d='M21.1449 25.4827C20.9801 25.0147 20.5919 24.7096 20.1614 24.7096H9.51617C9.23387 24.7096 8.96309 24.8416 8.76349 25.0765L1.31184 33.8431C1.00739 34.2013 0.916303 34.7399 1.08104 35.2079C1.24584 35.6759 1.63399 35.981 2.06452 35.981H12.7097C12.992 35.981 13.2628 35.8491 13.4624 35.6142L20.9141 26.8476C21.2186 26.4894 21.3097 25.9507 21.1449 25.4827Z'
      fill='#68646B'
    />
    <path
      d='M27.6124 35.981C27.34 35.981 27.0676 35.8587 26.8597 35.6142L20.1608 27.7331L13.4618 35.6142C13.0461 36.1032 12.372 36.1032 11.9564 35.6142C11.5406 35.125 11.5406 34.3321 11.9564 33.843L19.408 25.0764C19.8237 24.5873 20.4977 24.5873 20.9134 25.0764L28.3651 33.843C28.7808 34.3321 28.7808 35.125 28.3651 35.6142C28.1572 35.8587 27.8849 35.981 27.6124 35.981Z'
      fill='#8E8C96'
    />
    <path
      d='M4.19336 35.9811H10.5805V38.4858H4.19336V35.9811Z'
      fill='#B5ADB1'
    />
    <path
      d='M18.0315 35.9811C16.2677 35.9811 14.8379 37.6632 14.8379 39.7382V46.0001H21.225V39.7382C21.225 37.6632 19.7952 35.9811 18.0315 35.9811Z'
      fill='#68646B'
    />
    <path
      d='M47.7569 45.9999H33.0171C32.5648 45.9999 32.1982 45.5687 32.1982 45.0366V38.2929H48.5758V45.0366C48.5758 45.5687 48.2092 45.9999 47.7569 45.9999Z'
      fill='#C4BCC4'
    />
    <path
      d='M49.6344 38.0107L44.4813 31.9482L43.832 32.7121L48.5757 38.2929H50.2134C50.0039 38.2929 49.7943 38.1988 49.6344 38.0107Z'
      fill='#535058'
    />
    <path
      d='M47.7567 45.9999H37.9302C37.4779 45.9999 37.1113 45.5686 37.1113 45.0365V38.2929L42.8435 31.5492L48.5756 38.2929V45.0365C48.5756 45.5686 48.209 45.9999 47.7567 45.9999Z'
      fill='#F4EBF0'
    />
    <path
      d='M45.2385 30.2172C45.1117 29.8572 44.8131 29.6225 44.482 29.6225H36.2932C36.076 29.6225 35.8677 29.724 35.7142 29.9047L29.9821 36.6483C29.7479 36.9239 29.6778 37.3382 29.8045 37.6982C29.9313 38.0582 30.2299 38.2929 30.5611 38.2929H38.7498C38.967 38.2929 39.1753 38.1914 39.3288 38.0107L45.061 31.2671C45.2952 30.9915 45.3653 30.5772 45.2385 30.2172Z'
      fill='#68646B'
    />
    <path
      d='M50.2129 38.2929C50.0033 38.2929 49.7938 38.1988 49.6339 38.0107L44.4807 31.9482L39.3276 38.0107C39.0078 38.3869 38.4893 38.3869 38.1696 38.0107C37.8497 37.6345 37.8497 37.0245 38.1696 36.6483L43.9017 29.9046C44.2215 29.5284 44.74 29.5284 45.0597 29.9046L50.7919 36.6483C51.1117 37.0245 51.1117 37.6345 50.7919 38.0107C50.632 38.1988 50.4225 38.2929 50.2129 38.2929Z'
      fill='#8E8C96'
    />
    <path
      d='M32.1982 38.2929H37.1115V40.2197H32.1982V38.2929Z'
      fill='#B5ADB1'
    />
    <path
      d='M42.8424 38.2929C41.4856 38.2929 40.3857 39.5868 40.3857 41.183V45.9999H45.299V41.183C45.299 39.5868 44.1991 38.2929 42.8424 38.2929Z'
      fill='#68646B'
    />
    <path
      d='M64.7077 45.9999H54.3896C54.073 45.9999 53.8164 45.698 53.8164 45.3255V40.6049H65.2809V45.3255C65.2809 45.698 65.0243 45.9999 64.7077 45.9999Z'
      fill='#C4BCC4'
    />
    <path
      d='M66.0217 40.4073L62.4145 36.1635L61.96 36.6982L65.2806 40.6048H66.427C66.2803 40.6048 66.1336 40.539 66.0217 40.4073Z'
      fill='#535058'
    />
    <path
      d='M64.7068 46H57.8281C57.5115 46 57.2549 45.698 57.2549 45.3256V40.6049L61.2675 35.8843L65.28 40.6049V45.3256C65.28 45.698 65.0234 46 64.7068 46Z'
      fill='#F4EBF0'
    />
    <path
      d='M62.9443 34.9518C62.8556 34.6998 62.6465 34.5355 62.4147 34.5355H56.6825C56.5305 34.5355 56.3846 34.6066 56.2772 34.7331L52.2646 39.4537C52.1007 39.6466 52.0516 39.9367 52.1403 40.1887C52.2291 40.4407 52.4381 40.605 52.6699 40.605H58.4021C58.5542 40.605 58.7 40.5339 58.8075 40.4074L62.82 35.6868C62.984 35.4939 63.033 35.2038 62.9443 34.9518Z'
      fill='#68646B'
    />
    <path
      d='M66.4265 40.6049C66.2798 40.6049 66.1331 40.5391 66.0212 40.4074L62.4139 36.1636L58.8067 40.4074C58.5828 40.6707 58.2199 40.6707 57.996 40.4074C57.7722 40.144 57.7722 39.717 57.996 39.4536L62.0086 34.733C62.2324 34.4697 62.5954 34.4697 62.8192 34.733L66.8318 39.4536C67.0557 39.717 67.0557 40.144 66.8318 40.4074C66.7199 40.5391 66.5732 40.6049 66.4265 40.6049Z'
      fill='#8E8C96'
    />
    <path
      d='M53.8164 40.6049H57.2558V41.9536H53.8164V40.6049Z'
      fill='#B5ADB1'
    />
    <path
      d='M61.2675 40.6049C60.3178 40.6049 59.5479 41.5107 59.5479 42.628V45.9999H62.9872V42.628C62.9872 41.5107 62.2173 40.6049 61.2675 40.6049Z'
      fill='#68646B'
    />
    <path
      d='M30.0491 17.0531L29.6863 17.7095L30.1143 17.946L30.5034 17.6498L30.0491 17.0531ZM40.5191 9.08346L40.9146 8.44623L40.4758 8.17386L40.0649 8.48667L40.5191 9.08346ZM66.7367 25.9806C67.14 25.8862 67.3905 25.4828 67.2961 25.0795L65.7579 18.5071C65.6635 18.1037 65.26 17.8533 64.8567 17.9477C64.4534 18.0421 64.2029 18.4456 64.2973 18.8489L65.6646 24.691L59.8225 26.0583C59.4192 26.1527 59.1688 26.5562 59.2631 26.9595C59.3575 27.3628 59.761 27.6132 60.1643 27.5189L66.7367 25.9806ZM0.637242 1.65643L29.6863 17.7095L30.4119 16.3966L1.36276 0.343565L0.637242 1.65643ZM30.5034 17.6498L40.9734 9.68024L40.0649 8.48667L29.5948 16.4563L30.5034 17.6498ZM40.1236 9.72069L66.1703 25.8876L66.9613 24.6131L40.9146 8.44623L40.1236 9.72069Z'
      fill='#BBB2B7'
    />
  </Svg>
)

export default LowInventorySvg
